export const GRADIENT_CLASS_NAME =
  'bg-[linear-gradient(120deg,var(--tw-gradient-stops))] from-[#d1e5f2] -from-60% to-[#fff1eb]'

export const DEFAULT_GRADIENT_CLASS_NAME = `fixed left-0 top-0 h-full w-full -z-1 ${GRADIENT_CLASS_NAME}`
